import { writable } from 'svelte/store'

// Fuck Rollup, we're doing JavaScript now.
let glossary = writable({})

async function init() {
    glossary.set(await (
        await fetch('/plus-ewiko/wp-content/plugins/ewiko-selfcheck/api/glossary.php')
    ).json())
}

init()

export { glossary }